/**
 * @generated SignedSource<<678945003d9aa428d86d3f66a0b8cc20>>
 * @relayHash 0dcba740c649ce4d08ea1cb44c6b3b75
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0dcba740c649ce4d08ea1cb44c6b3b75

import { ConcreteRequest } from 'relay-runtime';
export type AiResult = "APPOINTMENT_IS_MISSING_CHAT_THREAD_ID" | "BREACHED_CONTENT_FILTER" | "FUNCTION_CALL" | "INVALID_QUESTIONNAIRE_DATA" | "JSON_ERROR" | "MAXIMUM_NUMBER_OF_TOKENS_EXCEEDED" | "MISSING_APPOINTMENT_DATA" | "MISSING_CALL_TRANSCRIPT" | "MISSING_CHAT_TRANSCRIPT" | "MISSING_CLINIBEE_GUIDELINES" | "MISSING_PROMPT_FOR_REQUESTED_LANGUAGE" | "MISSING_QUESTIONNAIRE_DATA" | "MISSING_USER_INPUT" | "MISSING_USER_PROMPT" | "NOT_FOUND_OPEN_AI_PROMPT" | "PROCESS_TIMEOUT" | "SUCCESS" | "TOOL_CALLS" | "UNKNOWN_ERROR" | "UNRESOLVED_PLACEHOLDER" | "UNSUPPORTED_PLACEHOLDER";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type AiRequestMetadataInput = {
  age: number;
  aiFeatureId: string;
  appointmentId: string;
  gender: Gender;
  progressNoteId?: string | null;
  progressNotes?: ReadonlyArray<ProgressNoteAnamnesisInput> | null;
  specialtyOfPointOfCareForCurrentProgressNote?: string | null;
  targetAgentLanguage?: Language | null;
  userInput?: string | null;
};
export type ProgressNoteAnamnesisInput = {
  anamnesis: string;
  updatedAt: string;
};
export type deChatHealthInformationCopilotQuery$variables = {
  aiRequestMetadata: AiRequestMetadataInput;
};
export type deChatHealthInformationCopilotQuery$data = {
  readonly chatHealthInformationCopilot: {
    readonly healthInformation: {
      readonly allergies: ReadonlyArray<{
        readonly comment: string | null;
        readonly diagnosis: {
          readonly diagnosisCode: string;
          readonly text: string;
        };
      }>;
      readonly conditions: ReadonlyArray<{
        readonly diagnosisCode: string;
        readonly text: string;
      }>;
      readonly medications: ReadonlyArray<string>;
    } | null;
    readonly result: AiResult;
  };
};
export type deChatHealthInformationCopilotQuery = {
  response: deChatHealthInformationCopilotQuery$data;
  variables: deChatHealthInformationCopilotQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aiRequestMetadata"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "aiRequestMetadata",
    "variableName": "aiRequestMetadata"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "diagnosisCode",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v4 = [
  (v2/*:: as any*/),
  (v3/*:: as any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "comment",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "medications",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "result",
  "storageKey": null
},
v8 = [
  (v2/*:: as any*/),
  (v3/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deChatHealthInformationCopilotQuery",
    "selections": [
      {
        "alias": "chatHealthInformationCopilot",
        "args": (v1/*:: as any*/),
        "concreteType": "ChatHealthInformationCopilotResult",
        "kind": "LinkedField",
        "name": "de_chatHealthInformationCopilot",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HealthInformation",
            "kind": "LinkedField",
            "name": "healthInformation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IcdDiagnosisWithComment",
                "kind": "LinkedField",
                "name": "allergies",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IcdDiagnosis",
                    "kind": "LinkedField",
                    "name": "diagnosis",
                    "plural": false,
                    "selections": (v4/*:: as any*/),
                    "storageKey": null
                  },
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IcdDiagnosis",
                "kind": "LinkedField",
                "name": "conditions",
                "plural": true,
                "selections": (v4/*:: as any*/),
                "storageKey": null
              },
              (v6/*:: as any*/)
            ],
            "storageKey": null
          },
          (v7/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deChatHealthInformationCopilotQuery",
    "selections": [
      {
        "alias": "chatHealthInformationCopilot",
        "args": (v1/*:: as any*/),
        "concreteType": "ChatHealthInformationCopilotResult",
        "kind": "LinkedField",
        "name": "de_chatHealthInformationCopilot",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HealthInformation",
            "kind": "LinkedField",
            "name": "healthInformation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IcdDiagnosisWithComment",
                "kind": "LinkedField",
                "name": "allergies",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IcdDiagnosis",
                    "kind": "LinkedField",
                    "name": "diagnosis",
                    "plural": false,
                    "selections": (v8/*:: as any*/),
                    "storageKey": null
                  },
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IcdDiagnosis",
                "kind": "LinkedField",
                "name": "conditions",
                "plural": true,
                "selections": (v8/*:: as any*/),
                "storageKey": null
              },
              (v6/*:: as any*/)
            ],
            "storageKey": null
          },
          (v7/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "0dcba740c649ce4d08ea1cb44c6b3b75",
    "metadata": {},
    "name": "deChatHealthInformationCopilotQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a0ca34ce017fd26b1e9e0b7bdc5dca6a";

export default node;
